import React, { Suspense, useCallback, useMemo, useState } from 'react'
import { goToCalculatorLink } from '@blocks/BlockInvestCalculator'
import { ANALITYCS_InvestorFordStartInvestingButtonIds } from '@constants/analitycs-ids'
import { QsParams } from '@constants/query-fields'
import { PageSettings } from '@http/api-models/page-settings'
import { PledgeSummaryResponse } from '@http/api-models/PledgeSummaryResponse'
import PageAnimation from '@shared/components/page-animation'
import { ExternalPaths } from '@shared/menu-items/paths'
import { getMarketingData } from '@shared/pipes/marketing-data'
import { yaCounter } from '@shared/pipes/ya-counter'
import dynamic from 'next/dynamic'

import { ModalSavings } from './ModalSavings/ModalSavings'
import { SectionAboutDeposit } from './SectionAboutDeposit'
import { SectionDeposit } from './SectionDeposit'
import { SectionInvestors } from './SectionInvestors'
import { SectionMain } from './SectionMain'
import { SectionMap } from './SectionMap'
import { SectionProtected } from './SectionProtected'
import { SectionStart } from './SectionStart'
import type { SavingCalculatorProgramsResponse } from '@http/api-models/SavingPrograms'
import type { SavingsParams } from 'ssr-resolvers/savings-params'
import { isProduction } from '@shared/pipes/config'

const BlockInvestCalculator = dynamic(() =>
	import('@blocks/BlockInvestCalculator/index').then((data) => data.BlockInvestCalculator)
)

const getQueryLink = (marketingData: QsParams) => {
	const queryKeys = Object.keys(marketingData)
	const queryLink = queryKeys.reduce((acc, param, index) => {
		const isLastParam = index === queryKeys.length - 1
		acc += `${param}=${marketingData[param]}${!isLastParam ? '&' : ''}`
		return acc
	}, '')
	return '?' + queryLink
}

const getInvestorLkLink = () => {
	const marketingData = getMarketingData()
	const queryLink = marketingData?.qsParams ? getQueryLink(marketingData.qsParams) : ''
	const entryUrl = marketingData.entryUrl
		? `refLink=${encodeURIComponent(marketingData.entryUrl)}`
		: ''

	return isProduction
		? ExternalPaths.investorLk + `?${[queryLink.slice(1), entryUrl].filter(Boolean).join('&')}`
		: ExternalPaths.testInvestorLk + `?${[queryLink, entryUrl].filter(Boolean).join('&')}`
}

export const openInvestorLkBlank = () => {
	window.open(getInvestorLkLink(), '_blank')
}

export interface InvestorsFondPageProps {
	pageSettings: PageSettings & {
		savings?: {
			params: SavingsParams
			programs: SavingCalculatorProgramsResponse
		}
		pledgeSummary?: PledgeSummaryResponse | undefined
	}
}

export const InvestorsFond = ({ pageSettings }: InvestorsFondPageProps) => {
	const [showModal, setShowModal] = useState(false)

	const onModalClose = useCallback(() => {
		setShowModal(false)
	}, [setShowModal])

	const { maxCashback, maxValue, minValue } = useMemo(() => {
		return (
			pageSettings?.savings?.params ||
			({
				maxCashback: '0',
				maxValue: '0',
				minValue: '0',
			} as any)
		)
	}, [pageSettings])

	return (
		<PageAnimation>

			<ModalSavings showModal={showModal} onModalClose={onModalClose} />
			<SectionMain
				maxCashback={maxCashback}
				buttonProps={{
					id: ANALITYCS_InvestorFordStartInvestingButtonIds(0),
					onClick: goToCalculatorLink,
				}}
			/>
			{/* <SectionBanks /> */}
			{/* <InvestFuture /> */}
			<SectionDeposit />
			<SectionProtected />
			<SectionMap pledgeSummary={pageSettings.pledgeSummary} />
			<Suspense>
				<BlockInvestCalculator
					annualInterestRate={[minValue, maxValue]}
					onButtonClick={() => {
						yaCounter.utils.reachGoal('invest_download_presentation')
						openInvestorLkBlank()
					}}
				/>
			</Suspense>
			{/* <SectionHow maxCashback={maxCashback} maxValue={maxValue} minValue={minValue} /> */}
			{/* <SectionFeedback /> */}
			{/* <SectionOpen /> */}
			<SectionAboutDeposit />
			<SectionInvestors />
			{/* <SectionApps /> */}
			<SectionStart goToInvestorLk={openInvestorLkBlank} />
			{/* <SectionGift /> */}
			{/* <SectionConsultNew /> */}

			{/* <Faq accordionElements={investFaq} /> */}
		</PageAnimation>
	)
}
